import { positive, fix2digit } from "../payment/Utilities";
import { computeTax } from "../payment/Utilities";

export function findSameItem(item, modifiers, cartItems) {
  if (item.reedemptionRule) return null;
  const records = cartItems.filter(
    (element) =>
      !element.reedemptionRule &&
      element.id == (item.hQID || item.id) &&
      compareTwoItemModifiers(modifiers, element.modifiers)
  );
  if (records.length > 0) return records[0];
  else return null;
}

function compareTwoItemModifiers(modifiers1, modifiers2) {
  var allSame = true;
  const oneIsEmpty =
    !modifiers1
      || !Array.isArray(modifiers1)
      || modifiers1.length === 0;
  const twoIsEmpty =
    !modifiers2
      || !Array.isArray(modifiers2)
      || modifiers2.length === 0;

  if(oneIsEmpty && twoIsEmpty) {
    return true;
  } else if((oneIsEmpty && !twoIsEmpty) || (!oneIsEmpty && twoIsEmpty)) {
    return false;
  }

  for (let element of modifiers1) {
    if (
      modifiers2.filter(
        (p) =>
          p.ID == element.ID &&
          p.quantity == element.quantity &&
          compareTwoItemModifiers(
            element.selectedSubmodifiers,
            p.selectedSubmodifiers
          )
      ).length == 0
    ) {
      allSame = false;
      break;
    }
  }

  for (let element of modifiers2) {
    if (
      modifiers1.filter(
        (p) =>
          p.ID == element.ID &&
          p.quantity == element.quantity &&
          compareTwoItemModifiers(
            element.selectedSubmodifiers,
            p.selectedSubmodifiers
          )
      ).length == 0
    ) {
      allSame = false;
      break;
    }
  }

  return allSame;
}

export function findSameGiftItem(item, message, cartItems) {
  let find = null;
  const records = cartItems.filter((element) => element.id == item.id);

  for (let j = 0; j < records.length; j++) {
    const record = records[j];
    if (messageEqual(record.message, message)) {
      find = record;
      break;
    }
  }
  return find;
}
export function calcTotalPrice(cartValue, deliveryFee, discount, holidaySurcharge = 0) {
  return positive(
    cartValue + (deliveryFee ? deliveryFee : 0) - (discount || 0) + holidaySurcharge
  );
}
export function itemQuantity(item, modifiers, cartItems) {
  const find = findSameItem(item, modifiers, cartItems);
  if (find) {
    return find.quantity;
  }
  return 0;
}
export function giftItemQuantity(item, message, giftCartItems) {
  const find = findSameGiftItem(item, message, giftCartItems);
  if (find) {
    return find.quantity;
  }
  return 0;
}
export function messageEqual(msg1, msg2) {
  if (
    msg1.Email != msg2.Email ||
    msg1.From != msg2.From ||
    msg1.To != msg2.To ||
    msg1.Message != msg2.Message
  )
    return false;
  return true;
}
export function calSurchargePercentage(elem) {
  let percentage = 0;

  switch (elem.RateType) {
    case 1:
      if (elem.Rate && elem.Rate >= 0) {
        percentage = elem.Rate;
      }
      break;
    case 2:
      if (elem.Rate) {
        if(elem.Rate == 0) {
          percentage = 0;
        } else if(elem.Rate > 0) {
          percentage = null;
        }
      }
      break;
  }

  if(percentage === null) {
    return null;
  } else {
    const stringified = (percentage * 100).toString();
    if(stringified.indexOf('.') > 0) {
      const first = stringified.split('.')[0];
      const second = stringified.split('.')[1];
      if(second.length === 1) {
        return percentage * 100
      } else {
        if(second.charAt(1) === 0) {
          return parseInt(first);
        } else {
          return parseFloat(first.concat('.', second.substring(0, 2)));
        }
      }
    } else {
      return percentage * 100;
    }
  }
}
export function calSurchargeAmount(elem, totalPrice) {
  let amount = 0;
  switch (elem.RateType) {
    case 1:
      if (elem.Rate && elem.Rate > 0) amount = elem.Rate * totalPrice;
      break;
    case 2:
      if (elem.Rate && elem.Rate > 0) amount = elem.Rate;
      break;
  }
  return fix2digit(amount);
}
export function calSurchargeTax(elem, totalPrice) {
  let tax = 0;
  if (elem.IsTaxable) {
    switch (elem.RateType) {
      case 1:
        if (elem.Rate && elem.Rate > 0)
          tax = computeTax({
            price: elem.Rate * totalPrice,
            taxRate: 0.1,
          });
        break;
      case 2:
        if (elem.Rate && elem.Rate > 0)
          tax = computeTax({
            price: elem.Rate,
            taxRate: 0.1,
          });
        break;
      default:
        break;
    }
  }
  return tax;
}
